import React, { useEffect } from 'react';
import Page from '../../../layout/Page';
import Daily from './daily';
import HourlyUseReport from './HourlyUseReport';
import HourlyBarReport from './HourlyBarReport';
import Revenue from './Revenue';
import Usage from './Usage';
import Transactions from './Transactions';
import Invoices from './Invoices';
import { userRoles } from '../../../RoleProtected';
import { useGlobalState } from '../../../stateProvider/StateProvider';
import ModalFactory from '../../../Modal';
import Col from '../../../layout/Col';
import LinkTo from '../../../forms/LinkTo';
import { generateId } from '../../../utility/functions';

const SalesReport = ({ children, ...props }) => {
    const {
        state: {
            locations,
            active_user
        },
    } = useGlobalState();

    useEffect(() => {
        if (locations.length < 1) {
            const isAdmin = active_user.roles.includes(userRoles.admin);
            const id = generateId();
            ModalFactory.show({
                id,
                type: 'warning',
                title: 'No Locations',
                body: (
                    <Col>
                        You have no Locations assigned to your account.
                        {isAdmin
                            ? <span>Go to <LinkTo to='/settings#UserManagement' onClick={() => ModalFactory.close(id)}>User Management</LinkTo> and assign yourself locations to view data on these reports.</span>
                            : <span>Please contact an administrator to have locations assigned to you for viewing data on these reports</span>
                        }
                    </Col>
                )
            })
        }
    }, [])

    return (
        <Page
            title='Sales'
            tabs
        >
            <Daily tab='Sales Summary' roles={userRoles.viewFinancialReports} />
            <Invoices tab='Invoices' roles={userRoles.viewAuditReports} />
            <HourlyUseReport tab='Hourly Use' roles={userRoles.viewUsageReports} />
            <HourlyBarReport tab='Hourly Bar Graph' roles={userRoles.viewUsageReports} />
            <Revenue tab='Revenue' roles={userRoles.viewFinancialReports} />
            <Usage tab='Usage' roles={userRoles.viewUsageReports} />
            <Transactions tab='Transactions' roles={userRoles.viewAuditReports} />
        </Page >
    );
}

export default SalesReport;
